import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getLocationItems } from "../utils/locationsData";
import { seededShuffleForDay } from "../utils/dailyRandom";
import { GalleryDetailGrid } from "../components/GalleryDetailGrid";
import "../components/Portfolio.css";
import "./LocationsPage.css";

const LocationDetailPage = () => {
  const { countryCode } = useParams();
  const [name, setName] = useState(countryCode);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // The route doesn't remount between country codes, so a slower fetch for a country the user
  // has already navigated away from could otherwise resolve after a newer one and overwrite it.
  const requestIdRef = useRef(0);

  useEffect(() => {
    const requestId = ++requestIdRef.current;
    const fetchImages = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await getLocationItems(countryCode);
        if (requestIdRef.current !== requestId) return;
        setName(result.name || countryCode);
        setImages(seededShuffleForDay(result.items, `location-grid:${countryCode}`));
      } catch (err) {
        if (requestIdRef.current !== requestId) return;
        console.error(`Error fetching ${countryCode} location:`, err);
        setError(err.message);
      } finally {
        if (requestIdRef.current === requestId) setLoading(false);
      }
    };

    fetchImages();
  }, [countryCode]);

  return (
    <div className="collection-detail">
      <div className="collection-header">
        <Link to="/locations" className="back-link">
          ← Locations
        </Link>
        <h1>
          {name}
          {!loading && !error && (
            <span className="location-detail-count">
              {" "}
              — {images.length} {images.length === 1 ? "photo" : "photos"}
            </span>
          )}
        </h1>
      </div>

      <GalleryDetailGrid
        items={images}
        loading={loading}
        error={error}
        altContext={name}
        emptyMessage="No photos from this location yet."
      />
    </div>
  );
};

export default LocationDetailPage;
